var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8749 7.63751C22.6414 7.40344 22.3243 7.2719 21.9936 7.2719C21.663 7.2719 21.3459 7.40344 21.1124 7.63751L14.9999 13.7375L8.8874 7.62501C8.65386 7.39094 8.3368 7.2594 8.00615 7.2594C7.67551 7.2594 7.35844 7.39094 7.1249 7.62501C6.6374 8.11251 6.6374 8.90001 7.1249 9.38751L13.2374 15.5L7.1249 21.6125C6.6374 22.1 6.6374 22.8875 7.1249 23.375C7.6124 23.8625 8.3999 23.8625 8.8874 23.375L14.9999 17.2625L21.1124 23.375C21.5999 23.8625 22.3874 23.8625 22.8749 23.375C23.3624 22.8875 23.3624 22.1 22.8749 21.6125L16.7624 15.5L22.8749 9.38751C23.3499 8.91251 23.3499 8.11251 22.8749 7.63751Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal_close.1b41c0a45888f197a51bbf93f94e0276.svg";
export { ForwardRef as ReactComponent };